import useExportDataQuery from 'basics/graphql/queries/exportData';

const useExport = () => (useExportDataQuery());

export default useExport;
